import { IIdentityLinksConfig, IIdentityProviderConfig, ISubscriberProviderConfig
    } from '../../../services/identity/adapters/adapter'
import { Entity } from '../../entity'

export interface IIdentityConfiguration {
    sso?: IIdentityProviderConfig
    subscriber?: ISubscriberProviderConfig
}

export class IdentityConfiguration extends Entity implements IIdentityConfiguration {
    public logo?: string
    public links?: IIdentityLinksConfig
    public property?: string
    public sso?: IIdentityProviderConfig
    public subscriber?: ISubscriberProviderConfig
    public showPasswordPolicy?: boolean

    public fromJson(jsonObject: object): IIdentityConfiguration {
        super.fromJson(jsonObject)

        // parse provider objects
        if ((jsonObject as this).links) {
            this.links = (jsonObject as this).links
        }
        if ((jsonObject as this).sso) {
            this.sso = (jsonObject as this).sso
        }
        if ((jsonObject as this).subscriber) {
            this.subscriber = (jsonObject as this).subscriber
        }

        return this
    }
}
